// import config from 'config'
import { title } from 'react-dom-factories'
import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

export const onChangeText = (type, text) => ({ type: types.ON_CHANGE, text })
export const onChangeTextGdpr = (type, text) => ({
  type: types.ON_CHANGE_GDPR,
  text,
})
// export const onChangeTextCertificateFooter = (type, text) => ({
//   type: types.ON_CHANGE_CERTIFICATE_FOOTER,
//   text,
// })

export const onChangeTextCertificateFooter = (text) => {
  return (dispatch, getState) => {
    dispatch({ type: types.ON_CHANGE_CERTIFICATE_FOOTER, text })
  }
}
export const toggleWelcomeEmail = () => ({ type: types.TOGGLE_WELCOME_EMAIL })
export const toggleGdprPage = (isShowing) => ({
  type: types.TOGGLE_GDPR_PAGE,
  isShowing,
})
export const setSettingsId = (id) => ({ type: types.GENERAL_SETTINGS_ID, id })
export const onChangeDashboardType = (dashboardType) => ({
  type: types.SET_DASHBOARD_TYPE,
  dashboardType,
})

export const onChangeDisplayUsersBy = (displayUsersBy) => ({
  type: types.DISPLAY_USERS_BY,
  displayUsersBy,
})
export const undo = () => ({ type: types.GENERAL_UNDO })
export const present = () => ({ type: types.GENERAL_PRESENT })
export const toggleFirstLink = () => ({
  type: types.ON_TOGGLE_FIRST_EXTERNAL_LINK,
})
export const toggleSecondLink = () => ({
  type: types.ON_TOGGLE_SECOND_EXTERNAL_LINK,
})
export const toggleThirdLink = () => ({
  type: types.ON_TOGGLE_THIRD_EXTERNAL_LINK,
})

export const toggleDisclaimerPage = (isShowing) => {
  return (dispatch) => {
    dispatch({ type: types.SET_DISCLAIMER_SHOWING, isShowing })
  }
}

export const saveGeneralSettings = () => {
  return (dispatch, getState) => {
    dispatch(present())
    dispatch({ type: types.GENERAL_PAGE_STATUS, status: 0 })

    const {
      disclaimerContent,
      gdprContent,
      disclaimerShowing,
      showGdpr,
      sendWelcomeEmail,
      pdfViewer,
      dashboardType,
      certificateType,
      displayUsersBy,
      defaultTab,
      showFirstLink,
      firstLink,
      showSecondLink,
      secondLink,
      showThirdLink,
      thirdLink,
      contactEmail,
      userRewardsOnDashboard,
      leaderBoardOnDashboard,
      corporateHierarchy,
      publicCatalogPercentage,
      allowAllLocationsAccess,
      certificateFooter,
      certificateFooterContent,
      managerAlertOnDashboard,
      pdfjsDownloadAndPrint,
      allowSignup,
      askCountry,
      askAge,
      enableLanguageFiles,
      comboardNotifications,
      messagesArchivePeriod,
      autoCompleteForms,
      disableLocationForms,
    } = getState().generalConfig

    console.log(certificateFooterContent, 'leart85')

    const firstLinkData = {
      enabled: showFirstLink ? 1 : 0,
      image: firstLink.icon,
      title: 'First Link',
      name: firstLink.name,
      url: firstLink.URL,
    }
    const secondLinkData = {
      enabled: showSecondLink ? 1 : 0,
      image: secondLink.icon,
      title: 'Second Link',
      name: secondLink.name,
      url: secondLink.URL,
    }
    const thirdLinkData = {
      enabled: showThirdLink ? 1 : 0,
      image: thirdLink.icon,
      title: 'Third Link',
      name: thirdLink.name,
      url: thirdLink.URL,
    }

    return AxiosInstance.post('/settings/general', {
      disclaimerContent,
      gdprContent,
      showDisclaimer: disclaimerShowing ? 1 : 0,
      showGdpr: showGdpr ? 1 : 0,
      pdfViewer,
      dashboardType,
      certificateType,
      displayUsersBy,
      sendWelcomeEmail: sendWelcomeEmail ? 1 : -1,
      defaultTab,
      contactEmail,
      external_links: JSON.stringify([
        firstLinkData,
        secondLinkData,
        thirdLinkData,
      ]),
      user_rewards_on_dashboard: userRewardsOnDashboard ? 1 : 0,
      leaderboard_on_dashboard: leaderBoardOnDashboard ? 1 : 0,
      corporate_hierarchy: corporateHierarchy ? 1 : 0,
      public_catalog_percentage: publicCatalogPercentage ? 1 : 0,
      allow_all_locations_access: allowAllLocationsAccess ? 1 : 0,
      certificate_footer: certificateFooter ? 1 : 0,
      certificateFooterContent,
      manager_alert_on_dashboard: managerAlertOnDashboard ? 1 : 0,
      pdfjs_download_and_print: pdfjsDownloadAndPrint ? 1 : 0,
      allow_signup: allowSignup ? 1 : 0,
      ask_country: askCountry ? 1 : 0,
      ask_age: askAge ? 1 : 0,
      enable_language_files: enableLanguageFiles ? 1 : 0,
      comboard_notifications: comboardNotifications ? 1 : 0,
      messages_expire_period: messagesArchivePeriod.value,
      auto_complete_forms: autoCompleteForms ? 1 : 0,
      disable_location_forms: disableLocationForms ? 1 : 0,
    }).then((data) => {
      if (data) {
        dispatch(setSettingsId(data.id || null))
      }

      dispatch({ type: types.GENERAL_PAGE_STATUS, status: 1 })
      dispatch(fetchGeneralSettings())
      setTimeout(() => {
        dispatch({ type: types.GENERAL_PAGE_STATUS, status: 0 })
      }, 500)
    })
  }
}
export const fetchGeneralSettings = () => {
  return (dispatch) => {
    AxiosInstance.get('/settings/general').then((data) => {
      dispatch({ type: types.GENERAL_SETTINGS_LOADED })
      dispatch({
        type: types.SET_GENERAL_SETTINGS,
        data,
      })
      dispatch({
        type: types.GET_EXTERNAL_LINKS,
        data: JSON.parse(data.external_links),
      })
      dispatch(present())
    })
  }
}

export const fetchGdprContent = () => {
  return (dispatch) => {
    AxiosInstance.get('/settings/general/gdpr').then((data) => {
      dispatch({
        type: types.SET_GDPR_DATA,
        gdprContent: data.gdprContent,
        showGdpr: data.showGdpr,
      })
    })
  }
}

export const agreeDisclaimer = () => {
  return (dispatch, getState) => {
    localStorage.setItem('disclaimer', true)
    dispatch({ type: types.GENERAL_DISCLAIMER_AGREE })
  }
}

export const disagreeDisclaimer = () => {
  return (dispatch, getState) => {
    localStorage.removeItem('access_token')

    // location = `${config.basename}/login`
  }
}

export const fetchRedirectUrl = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/users/logout').then((data) => {
      if (data && data.url) {
        window.location = data.url
        return
      }
      // window.location = `${config.basename}/login`
    })
  }
}

// Set pdf viewer in general settings
export const setPdfViewer = (selectedPdfViewer) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_PDF_VIEWER,
      selectedPdfViewer,
    })
  }
}

export const onChangeRedirectSettings = (defaultTab) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_DEFAULT_TAB,
      defaultTab,
    })
  }
}

export const onChangeLink = (event) => {
  return (dispatch) => {
    const name = event.target.name
    const value = event.target.value
    const groupId = event.target.className
    dispatch({ type: types.ON_CHANGE_EXTERNAL_LINK, name, value, groupId })
  }
}

// export const onSaveLink = (event) => {
//   return (dispatch, getState) => {
//     event.preventDefault()

//     const nodes = event.target.elements
//     const nameInput = [].filter.call(nodes, (item) => item.type === 'text')[0]
//     const URLInput = [].filter.call(nodes, (item) => item.type === 'text')[1]
//     const iconInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

//     const name = nameInput.value
//     const URL = URLInput.value
//     const icon = iconInput.files[0]
//     const inputGroup = nameInput.className || URLInput.className
//     const data = new FormData()

//     let currentLink = inputGroup === '1' ? getState().general.firstLink :
//                       inputGroup === '2' ? getState().general.secondLink :
//                       inputGroup === '3' ? getState().general.thirdLink : null

//     data.append('name', name)
//     data.append('URL', URL)
//     if (icon) {
//       data.append('file', icon)
//       currentLink.icon = icon.name
//     }

//     currentLink.isDisabled = true
//     currentLink.isSaved = true

//     dispatch({ type: types.SAVE_LINK, value: currentLink })
//   }
// }
export const onChangeCertificateType = (certificateType) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CERTIFICATE_TYPE, certificateType })
  }
}
export const onChangeContactEmail = (event) => {
  return (dispatch, getState) => {
    const contactEmail = event.target.value
    dispatch({ type: types.SET_CONTACT_EMAIL, contactEmail })
  }
}

export const setMessagesArchivePeriod = (period) => ({
  type: types.SET_MESSAGES_ARCHIVE_PERIOD,
  payload: period,
})

export const fetchZoom = (event) => {
  return (dispatch, getState) => {
    AxiosInstance.get('settings/zoomGenerate')
      .then((response) => {
        if (response && response.authorize_url) {
          dispatch({
            type: types.GET_EXTERNAL_APPS,
            data: { zoom: { ...response, has_authorized: false } },
          })
        } else {
          dispatch({
            type: types.GET_EXTERNAL_APPS,
            data: { zoom: { authorize_url: null, has_authorized: true } },
          })
        }
      })
      .catch((err) => {
        dispatch({
          type: types.GET_EXTERNAL_APPS,
          data: { zoom: { authorize_url: null, has_authorized: true } },
        })
      })
  }
}

export const enableUserRewardsOnDashboard = () => ({
  type: types.ENABLE_USER_REWARDS,
})
export const enableLeaderBoardOnDashboard = () => ({
  type: types.ENABLE_LEADERBOARD,
})

export const enableComboardNotifications = () => ({
  type: types.ENABLE_COMBOARD_NOTIFICATIONS,
})

export const enableManagerAlertOnDashboard = () => ({
  type: types.ENABLE_MANAGER_ALERT,
})

export const enablePdfjsDownloadAndPrint = () => ({
  type: types.ENABLE_PDFJS_DOWNLOAD_AND_PRINT,
})

export const allowSignup = () => ({
  type: types.ALLOW_SIGNUP,
})

export const askCountry = () => ({
  type: types.ASK_COUNTRY,
})

export const askAge = () => ({
  type: types.ASK_AGE,
})

export const enableLanguageFiles = () => ({
  type: types.ENABLE_LANGUAGE_FILES,
})

export const autoCompleteForms = () => ({
  type: types.AUTO_COMPLETE_FORMS,
})

export const disableLocationForms = () => ({
  type: types.DISABLE_LOCATION_FORMS,
})

export const enableCorporateHierarchy = () => ({
  type: types.ENABLE_CORPORATE_HIERARCHY,
})

export const enablePublicCatalogPercentage = () => ({
  type: types.ENABLE_PUBLIC_CATALOG_PERCENTAGE,
})

export const allowAllLocationsAccess = () => ({
  type: types.ALLOW_ALL_LOCATIONS_ACESS,
})

export const enableCertificateFooter = () => ({
  type: types.ENABLE_CERTIFICATE_FOOTER,
})

export const setIsBlocking = (isBlocking) => ({
  type: types.SET_IS_BLOCKING,
  isBlocking: isBlocking,
})

export const setShowSidebarDropdownChildRoutes = (payload) => ({
  type: types.SET_SHOW_SIDEBAR_CHILD_ROUTES,
  payload,
})
